export const SOCIALS = {
	twitterUrl: 'https://twitter.com/pixelteh',
	facebookUrl: 'https://www.facebook.com/pixelteh/',
	linkedinUrl: 'https://www.linkedin.com/company/pixelteh/',
	instagramUrl:
		'https://instagram.com/pixeltehdev?utm_source=ig_profile_share&igshid=1m28ujzthx1y1',
	youtubeUrl: 'https://www.youtube.com/channel/UCkabRS4NM9k-jyECnZ5N97A',
};
